import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContainer from './ModalContainer';
import BodyText from 'components/typography/BodyText';
import Button from 'components/button/Button';
import { notifySuccess } from 'utils/notify';
import { generateGuestAccessLink } from 'utils/url';

interface IGuestAccessLinkModal {
  isOpen: boolean;
  onClose: () => void;
  originId: string;
  orgId?: string;
  originType: 'community' | 'program';
  allowGuest?: boolean;
  guestViewCount: number;
}

const GuestAccessLinkModal = ({
  isOpen,
  originId,
  originType,
  orgId,
  allowGuest,
  guestViewCount,
  onClose,
}: IGuestAccessLinkModal) => {
  const { t } = useTranslation();
  const inviteUrl = generateGuestAccessLink(originId, originType, orgId ? orgId : undefined);
  const iframeLink = `<iframe src="${inviteUrl}" name="SCIFrame" width="100%" height="500px" style="border: solid #808080; border-radius: 10px;"></iframe>`;
  const [copiedState, setCopiedState] = useState<Record<string, boolean>>({});
  const copyToClipboard = (text: string) => {
    setCopiedState({ ...copiedState, [text]: true });
    navigator.clipboard.writeText(text);
    notifySuccess(t('invite-copied'));
  };

  return (
    <ModalContainer isOpen={isOpen} onClose={onClose}>
      {allowGuest ? (
        <div>
          <table className='w-full table-auto items-center justify-center '>
            <thead>
              <tr>
                <th className='min-w-[100px] border-b px-4 py-2'>
                  {t('invitation-link')} {t('url')}
                </th>
                <th className='border-b py-2'>{t('view_count')}</th>
                <th className='border-b px-4 py-2'></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className='px-4 py-2'>
                  <div className='flex flex-col '>
                    <BodyText variant='sm' className='font-bold text-secondary-500'>
                      <a href={inviteUrl} target='_blank' rel='noopener noreferrer'>
                        Read-Only Link
                      </a>
                    </BodyText>
                  </div>
                </td>
                <td className='px-4 py-2'>{Math.round(guestViewCount / 3)}</td>
                <td className=' px-4 py-2'>
                  <Button size='small' variant='primary' onClick={() => copyToClipboard(inviteUrl)}>
                    {copiedState[inviteUrl] ? t('copied') : t('copy')}
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
          <table className='mt-4 w-full table-auto items-center justify-center '>
            <thead>
              <tr>
                <th className='min-w-[100px] border-b px-4 py-2'>{t('embed_iframe')}</th>
                <th className='border-b py-2'>{t('view_count')}</th>
                <th className='border-b px-4 py-2'></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className='px-4 py-2'>
                  <div className='flex flex-col '>
                    <BodyText variant='sm' className='font-bold text-secondary-500'>
                      <a href={iframeLink} target='_blank' rel='noopener noreferrer'>
                        iFrame Link
                      </a>
                    </BodyText>
                  </div>
                </td>
                <td className='px-4 py-2'>{Math.round(guestViewCount / 3)}</td>
                <td className=' px-4 py-2'>
                  <Button
                    size='small'
                    variant='primary'
                    onClick={() => copyToClipboard(iframeLink)}
                  >
                    {copiedState[iframeLink] ? t('copied') : t('copy')}
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center'>
          <BodyText variant='base' className=' text-center  text-neutral-500'>
            {t('guest-access-disabled')}
          </BodyText>
        </div>
      )}
      <div className='mt-5 flex justify-end gap-3 border-t border-neutral-200 pt-5'>
        <Button type='button' size='small' variant='secondary' onClick={onClose}>
          {t('close')}
        </Button>
      </div>
    </ModalContainer>
  );
};

export default GuestAccessLinkModal;
